import { Column } from './types';

export const RSA_KEY2KEY_REPORT_NAME = 'RSA Key2Key Report';
export const RSA_KEY2KEY_REPORT_TITLE = 'RSAKey2KeyReport';

export const RSA_KEY2KEY_REPORT_MESSAGE =
  'This report shows the number of RSA Key2Key transactions for each month.';

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const date = new Date();
const currentYear = date.getFullYear();
const years = Array.from(
  { length: currentYear - 1990 + 1 },
  (v, k) => currentYear - k
);
export const selectOptions = years.map((year) => ({
  id: year,
  text: `${year}`,
  value: `${year}`,
}));

export const columns: Column[] = [
  { name: 'code', title: 'Code' },
  {
    name: 'year',
    title: 'Year',
  },
  {
    name: 'month',
    title: 'Month',
  },
  {
    name: 'key2Key',
    title: 'Key2Key',
    type: 'number',
  },
  {
    name: 'sumLabourHours',
    title: 'Sum Labour Hours',
        type: 'number',
  },
  {
    name: 'avgLabourHours',
    title: 'Average Labour Hours',
        type: 'number',
  },
  {
    name: 'avgOnsiteToStarted',
    title: 'Average Onsite To Started',
        type: 'number',
  },
  {
    name: 'avgStartToCompleted',
    title: 'Average Start To Completed',
        type: 'number',
  },
  {
    name: 'avgCompletedToDelivered',
    title: 'Avearge Completed To Delivered',
        type: 'number',
  },
];

